<template>
	<div id="rightTopDom" style="overflow: hidden;">
		<div class="tapDom">
			<div class="ulDom">
				<div class="ul">
					<div class="lli" @click="changeRightTopCheck('1')">
						<img :src="rightTopCheck == '1' ? selectImg0 : selectImg1" alt="">
						<div><span>{{ languageJson.ComprehensiveScore }}</span></div>
					</div>
					<div class="lli" style="margin:0 10px;" @click="changeRightTopCheck('2')">
						<img :src="rightTopCheck == '2' ? selectImg0 : selectImg1" alt="">
						<div><span>{{ languageJson.ProcessingEfficiency}}</span></div>
					</div>
					<div class="lli" @click="changeRightTopCheck('3')">
						<img :src="rightTopCheck == '3' ? selectImg0 : selectImg1" alt="">
						<div><span>{{ languageJson.ProcessingQuantity }}</span></div>
					</div>
				</div>
				<div class="daySelect" style="width: 20%;">
					<el-select v-model="selectValue" style="width: 100%;height: 100%;">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
			</div>
		</div>
		<div v-if="rightTopCheck == '1'" class="echarsUl">
			<el-carousel ref="carouselRef" :autoplay='false' trigger='click' style="height: 100%;">
				<el-carousel-item v-for="item in Math.ceil(staffVos.staffScoreList.length/3)" :key="item">
					<div v-if="(item == '1' && staffVos.staffScoreList[0]) || (item == '2' && staffVos.staffScoreList[3])" class="echarsLi">
						<div class="itemTop" :style="{backgroundImage: 'url(' + valBack + ')'}">
							<div class="title">
								<img src="../../../../static/imgV2/ranking1.png" alt="">
								<div class="score">
									<span
										style="font-size: 1.1vw;font-weight: 800;">{{ item == '1' ? staffVos.staffScoreList[0].score : staffVos.staffScoreList[3].score }}</span>
									<span style="font-size: 0.7vw;">{{ item == '1' ? staffVos.staffScoreList[0].name : staffVos.staffScoreList[3].name }}</span>
								</div>
							</div>
						</div>
						<div class="itemBottom">
							<div
								v-if="(item == '1' && staffVos.staffScoreList[1]) || (item == '2' && staffVos.staffScoreList[4])"
								:style="{backgroundImage: 'url(' + valBack2 + ')',backgroundSize: '100% 100%',justifyContent: 'space-between',width: '40%',height: '100%'}">
								<div class="title" style="margin-top: -15%;">
									<img src="../../../../static/imgV2/ranking2.png" alt="">
									<div class="score">
										<span
											style="font-size: 1.1vw;font-weight: 800;">{{ item == '1' ? staffVos.staffScoreList[1].score : staffVos.staffScoreList[4].score }}</span>
										<span style="font-size: 0.7vw;">{{ item == '1' ? staffVos.staffScoreList[1].name : staffVos.staffScoreList[4].name }}</span>
									</div>
								</div>
							</div>
							<div
								v-if="(item == '1' && staffVos.staffScoreList[2]) || (item == '2' && staffVos.staffScoreList[5])"
								:style="{backgroundImage: 'url(' + valBack + ')',backgroundSize: '100% 100%',justifyContent: 'space-between',width: '40%',height: '100%'}">
								<div class="title" style="margin-top: -15%;">
									<img src="../../../../static/imgV2/ranking3.png" alt="">
									<div class="score">
										<span
											style="font-size: 1.1vw;font-weight: 800;">{{ item == '1' ? staffVos.staffScoreList[2].score : staffVos.staffScoreList[5].score }}</span>
										<span style="font-size: 0.7vw;">{{ item == '1' ? staffVos.staffScoreList[2].name : staffVos.staffScoreList[5].name }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-carousel-item>
			</el-carousel>
		</div>
		<div v-if="rightTopCheck == '2'" style="width: 100%;height: 85%;">
			<div v-if="rightTopCheck == '2'" ref="echar1_2" style="width: 100%;height: 100%;"></div>
		</div>
		<div v-if="rightTopCheck == '3'" style="width: 100%;height: 85%;">
			<div v-if="rightTopCheck == '3'" ref="echar1_3" style="width: 100%;height: 100%;"></div>
		</div>
	</div>
</template>

<script>
	import {
		scoreList
	} from '@/api/indexV2'
	import {
		getItem
	} from '@/utils/auth'
	export default {
		data() {
			return {
				languageJson: languageJson,
				languageCheck: localStorage.getItem('language'),
				selectImg0: require('../../../../static/imgV2/checkSelect-0.png'),
				selectImg1: require('../../../../static/imgV2/checkSelect-1.png'),
				valBack: require('../../../../static/imgV2/one-1.png'),
				valBack2: require('../../../../static/imgV2/one-2.png'),
				rightTopCheck: '1',
				selectValue: '1',
				options: [{
					value: '1',
					label: languageJson.Week
				}, {
					value: '2',
					label: languageJson.Month
				}],
				staffVos: {
					staffList: [],
					staffScoreList: []
				},
				myChart_1: null,
				myChart_2: null,
				rightCheck: '0'
			}
		},
		props: {
			timeStamp: Number,
			changeTime: Boolean
		},
		mounted() {
			let that = this
			that.scoreList(that.selectValue, that.rightTopCheck)
		},
		methods: {
			fontSizeCh(res) {
				// 获取屏幕宽度
				if (window.screen.width <= 1920) {
					return res
				} else if (window.screen.width > 1920 && window.screen.width <= 3200) {
					return res * 1.5
				} else if (window.screen.width > 3200 && window.screen.width <= 3840) {
					return res * 2.2
				} else if (window.screen.width > 3840) {
					return res * 3
				}
			},
			scoreList(day, type) {
				let that = this
				scoreList(getItem('tenantInfoId'),day).then(res => {
					if (res && res.data) {
						that.staffVos = res.data
						if (type == '2') {
							that.drawEcharRight1()
						} else if (type == '3') {
							that.drawEcharRight2()
						}
						that.setTimeStaff()
					}
				})
			},
			setTimeStaff() {
				let that = this
				if (that.staffVos.staffScoreList.length > 3) {
					setInterval(() => {
						if (that.rightCheck == '0') {
							that.$refs.carouselRef.setActiveItem('1')
							that.rightCheck = '1'
						} else {
							that.$refs.carouselRef.setActiveItem('0')
							that.rightCheck = '0'
						}
					}, 1500)
				}
			},
			changeRightTopCheck(type) {
				this.rightTopCheck = type
				if (type == '2') {
					this.drawEcharRight1()
				} else if (type == '3') {
					this.drawEcharRight2()
				}
			},
			drawEcharRight1() {
				let that = this
				let xData = []
				let yData1 = []
				let yData2 = []
				let data = that.staffVos
				data.staffList.forEach((res) => xData.push(res.name))
				data.staffList.forEach((res) => {
					let xDataObj = data.staffScoreList.find((rex) => rex.staffId == res.staffId)
					yData1.push(xDataObj ? Number(xDataObj.highAvgTime) : 0)
					yData2.push(xDataObj ? Number(xDataObj.normalAvgTime) : 0)
				})
				that.$nextTick(() => {
					var myChart = that.$echarts.init(that.$refs.echar1_2);
					that.myChart_1 = myChart;
					let option = {
						tooltip: {
							trigger: 'axis',
							textStyle: {
								fontSize: that.fontSizeCh(14)
							},
							axisPointer: {
								type: 'cross',
								crossStyle: {
									color: '#ffffff'
								}
							}
						},
						grid: {
							top: '50px',
							left: '10px',
							bottom: '20px',
							right: '20px',
							containLabel: true
						},
						legend: {
							data: [languageJson.AdvancedEvents, languageJson.OrdinaryEvents],
							color: ['#ffffff', '#00FF00'],
							textStyle: {
								color: '#ffffff',
								fontSize: that.fontSizeCh(12)
							},
							top: '1%',
							right: '5%'
						},
						xAxis: [{
							type: 'category',
							data: xData,
							axisPointer: {
								type: 'shadow'
							},
							axisLabel: {
								textStyle: {
									color: '#ffffff',
									fontSize: that.fontSizeCh(14)
								}
							}
						}],
						yAxis: [{
							type: 'value',
							axisLabel: {
								formatter: '{value}',
								textStyle: {
									color: '#ffffff',
									fontSize: that.fontSizeCh(14)
								}
							}
						}],
						series: [{
								name: languageJson.AdvancedEvents,
								type: 'bar',
								tooltip: {
									valueFormatter: function(value) {
										return value;
									}
								},
								data: yData1
							},
							{
								name: languageJson.OrdinaryEvents,
								type: 'bar',
								tooltip: {
									valueFormatter: function(value) {
										return value;
									}
								},
								data: yData2,
							}
						]
					};
					myChart.setOption(option)
				})
			},
			drawEcharRight2() {
				let that = this
				let xData = []
				let yData1 = []
				let yData2 = []
				let data = that.staffVos
				data.staffList.forEach((res) => xData.push(res.name))
				data.staffList.forEach((res) => {
					let xDataObj = data.staffScoreList.find((rex) => rex.staffId == res.staffId)
					yData1.push(xDataObj ? Number(xDataObj.highNum) : 0)
					yData2.push(xDataObj ? Number(xDataObj.normalNum) : 0)
				})
				that.$nextTick(() => {
					var myChart = that.$echarts.init(that.$refs.echar1_3);
					that.myChart_2 = myChart
					let option = {
						tooltip: {
							trigger: 'axis',
							textStyle: {
								fontSize: that.fontSizeCh(14)
							},
							axisPointer: {
								type: 'cross',
								crossStyle: {
									color: '#ffffff'
								}
							}
						},
						legend: {
							data: [languageJson.AdvancedEvents, languageJson.OrdinaryEvents],
							color: ['#ffffff', '#00FF00'],
							textStyle: {
								color: '#ffffff',
								fontSize: that.fontSizeCh(12)
							},
							top: '1%',
							right: '5%'
						},
						grid: {
							top: '50px',
							left: '10px',
							bottom: '20px',
							right: '20px',
							containLabel: true
						},
						xAxis: {
							type: 'value',
							boundaryGap: [0, 0.01],
							axisLabel: {
								textStyle: {
									color: '#ffffff',
									fontSize: that.fontSizeCh(14)
								}
							}
						},
						yAxis: {
							type: 'category',
							data: xData,
							axisLabel: {
								textStyle: {
									color: '#ffffff',
									fontSize: that.fontSizeCh(14)
								}
							}
						},
						series: [{
								name: languageJson.AdvancedEvents,
								type: 'bar',
								data: yData1,

							},
							{
								name: languageJson.OrdinaryEvents,
								type: 'bar',
								data: yData2
							}
						]
					};
					myChart.setOption(option)
				})
			}
		},
		watch: {
			changeTime: {
				deep: true,
				immediate: false,
				handler(newData, oldData) {
					if (this.rightTopCheck == '1') {
						this.changeRightTopCheck('2')
					} else if (this.rightTopCheck == '2') {
						this.changeRightTopCheck('3')
					} else {
						this.changeRightTopCheck('1')
					}
				}
			},
			selectValue: {
				deep: true,
				immediate: true,
				handler(newData, oldData) {
					this.scoreList(newData, this.rightTopCheck)
				}
			},
			timeStamp: {
				deep: true,
				immediate: true,
				handler(newData, oldData) {
					let that = this
					if (newData) {
						if (that.myChart_1) { that.myChart_1.resize() }
						if (that.myChart_2) { that.myChart_2.resize() }
					}
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.daySelect /deep/ .el-input__inner {
		background-color: #0B258C;
		color: white;
		border: 1px solid #1D71FF;
		height: 1.5vw;
		line-height: 1.5vw;
		font-size: 0.7vw;
	}

	.daySelect /deep/ .el-input__icon {
		height: 1.5vw;
		line-height: 1.5vw;
	}

	.daySelect /deep/ .el-select .el-input,
	.el-select-dropdown .el-select-dropdown__item {
		font-size: 0.7vw;
		height: 1.3vw;
		line-height: 1.3vw;
	}

	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 300px;
		margin: 0;
	}
	.el-carousel__item:nth-child(2n) {}
	.el-carousel__item:nth-child(2n+1) {}

	#rightTopDom {
		height: 100%;
		position: relative;
	}

	#rightTopDom /deep/ .el-carousel__container {
		height: 100%;
	}

	#rightTopDom /deep/ .el-carousel__indicators--horizontal {
		display: none;
	}

	.tapDom {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 15%;
		margin-top: 15px;

		.ulDom {
			display: flex;
			justify-content: space-between;
			width: 90%;
			margin: 10px auto;
			align-items: center;

			.ul {
				display: flex;
				width: 80%;
				// margin-top: 5px;

				.lli {
					width: 30%;
					height: 100%;
					position: relative;

					img {
						width: 100%;
						height: 100%;
					}

					div {
						position: absolute;
						top: 0;
						left: 10%;
						width: 80%;
						height: 80%;
						display: flex;
						justify-content: center;
						align-items: center;
						color: white;
						font-weight: 700;
						cursor: pointer;
						font-size: 0.9vw;
					}
				}
			}
		}
	}

	.echarsUl {
		width: 90%;
		margin: 10px auto;
		height: 75%;

		.echarsLi {
			width: 100%;
			height: 100%;
			margin-top: 5%;
			color: white;

			.title {
				margin-top: -20%;
				display: flex;
				align-items: center;
				justify-content: center;

				.score {
					display: flex;
					align-content: flex-start;
					flex-direction: column;
					justify-content: center;
					align-items: flex-start;
				}

				img {
					width: 30%;
				}
			}
		}
	}

	.itemTop {
		background-size: 100% 100%;
		width: 60%;
		height: 45%;
		margin: 0 auto;
		display: flex;
		justify-content: center;
		align-items: center;
		color: white;
	}

	.itemBottom {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 40%;
	}
</style>



// WEBPACK FOOTER //
// src/page/customIndex/components/rightTop.vue